// src/LoginSetUp.js
import {
  Box,
  Button,
  Card,
  CircularProgress,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GlobalContext } from '../../contaxt/GlobalContext';
import ApiClient from '../../helpers/ApiClient';
import apiEndPoints from '../../helpers/apiEndPoints';
import bgImg from '../../images/Main-Page.jpg';

const useStyles = makeStyles({
  container: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: `url(${bgImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },
  card: {
    maxWidth: 550,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '70px 60px',
    textAlign: 'center',
    borderRadius: '0px !important',
    '& .MuiTypography-h5 ': {
      fontSize: 30,
      fontFamily: 'Conv_AtlasGrotesk-Medium-App',
    },
    '& .MuiTypography-body2': {
      fontSize: 18,
      marginBottom: '40px',
      lineHeight: '22px',
      color: '#444444',
    },
  },
  inputField: {
    borderBottom: '1px solid #ccc',
    '& input': {
      padding: '6px 0',
      borderBottom: '1px solid #ccc',
    },
  },
  getCodeBtn: {
    marginTop: '26px !important',
    backgroundColor: '#000 !important',
    color: '#fff !important',
    borderRadius: '0px !important',
    height: 46,
    textTransform: 'none !important',
    '&:disabled': {
      backgroundColor: '#dfdfdf !important',
      color: '#fff !important',
    },
  },
  codeBox: {
    width: '100%',
    minHeight: '50px',
    borderBottom: '1.5px solid #ccc',
    padding: '0 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '20px',
    userSelect: 'none',
    boxSizing: 'border-box',
    overflow: 'hidden',
    letterSpacing: '10px',
  },
  codeInput: {
    width: '24px',
    height: '40px',
    textAlign: 'center',
    fontSize: '18px',
    background: 'transparent',
    border: 'none',
    outline: 'none',
    color: '#000',
    '&:focus': {
      outline: 'none',
      border: 'none',
    },
  },
  dash: {
    display: 'inline-block',
    width: '24px',
    textAlign: 'center',
    fontSize: '20px',
    color: '#dfdfdf',
    userSelect: 'none',
  },
  errorMassage: {
    margin: '8px 0',
    textAlign: 'left',
    fontSize: 14,
    fontWeight: 600,
    color: '#cf1414',
  },
  confirmBtn: {
    marginTop: '20px !important',
    backgroundColor: '#000 !important',
    color: '#fff !important',
    borderRadius: '0px !important',
    height: '46px !important',
    textTransform: 'none !important',
    cursor: 'pointer',
    '&:disabled': {
      backgroundColor: '#ccc !important',
      color: '#fff !important',
    },
  },
  resend: {
    margin: '36px 0 10px 0 !important',
    cursor: 'pointer',
    fontSize: '16px',
    background: 'none',
    border: 'none',
    color: '#444444',
    fontWeight: '700',
  },
});

function MFASetup() {
  const classes = useStyles();
  const history = useHistory();
  const { email, password } = useContext(GlobalContext);
  const [mobile, setMobile] = useState('');
  const [error, setError] = useState('');
  const [resendError, setResendError] = useState('');
  const [showVerification, setShowVerification] = useState(false);
  const [code, setCode] = useState(Array(6).fill(''));
  const [maskedMobile, setMaskedMobile] = useState('');
  const [loading, setLoading] = useState(false);
  const slotsCount = 6;
  const [disabled, setDisabled] = useState(false);
  const [timer, setTimer] = useState(0);

  const handleVerificationClick = () => {
    const payload = {
      email,
      password,
      mobileNumber: mobile,
    };
    setLoading(true);
    ApiClient.apiPost(apiEndPoints.login, payload)
      .then(response => {
        if (response.status === 200) {
          setMaskedMobile(response?.data?.data?.maskedMobile);
          setError('');
          setShowVerification(true);
          setCode(Array(slotsCount).fill(''));
        } else {
          setError('Invalid credentials. Please try again.');
        }
        setLoading(false);
      })
      .catch(err => {
        setError(err?.response?.data?.message);
        setLoading(false);
      });
  };

  const resendVerification = () => {
    const payload = {
      email,
      password,
      mobileNumber: mobile,
      resendOtp: true,
    };
    setLoading(true);
    setDisabled(true);
    setTimer(60);
    ApiClient.apiPost(apiEndPoints.login, payload)
      .then(response => {
        if (response.status === 200) {
          setMaskedMobile(response?.data?.data?.mobileNumber);
          setResendError('');
          setShowVerification(true);
          setCode(Array(slotsCount).fill(''));
        } else {
          setResendError('Invalid credentials. Please try again.');
        }
        setLoading(false);
      })
      .catch(err => {
        setResendError(err?.response?.data?.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    let interval;
    if (disabled && timer > 0) {
      interval = setInterval(() => {
        setTimer(prev => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setDisabled(false);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [disabled, timer]);

  const handleConfirmCode = () => {
    const enteredCode = code.join('');
    const payload = {
      email,
      password,
      mobileNumber: mobile,
      otp: enteredCode,
    };
    setLoading(true);
    ApiClient.apiPost(apiEndPoints.login, payload)
      .then(response => {
        if (response.status === 200) {
          setError('');
          history.push('/manage-staff-list');
        } else {
          setError('The code you entered is incorrect. Please try again.');
        }
        setLoading(false);
      })
      .catch(err => {
        setError(err?.response?.data?.message);
        setLoading(false);
      });
  };

  return (
    <Box className={classes.container}>
      <Card className={classes.card}>
        <Typography variant="h5" gutterBottom>
          Set Up MFA
        </Typography>
        <Typography variant="body2" align="left" gutterBottom>
          In order to set up your Smart Keys, we need to verify your phone
          number. We won’t ever use your number for marketing.
          <br />
          {maskedMobile && ` Code sent to ${maskedMobile}`}
        </Typography>

        {!showVerification &&
          (loading ? (
            <div className="signingInWaitMain">
              <CircularProgress
                color="inherit"
                className="crcularprogressSignin"
              />
            </div>
          ) : (
            <div style={{ width: '100%' }}>
              <p
                align="left"
                style={{ fontSize: 16, marginBottom: '16px', color: '#838384' }}
              >
                Mobile number
              </p>
              <TextField
                fullWidth
                variant="standard"
                value={mobile}
                onChange={e => {
                  const { value } = e.target;
                  if (/^\+\d*$/.test(value)) {
                    const digitsOnly = value.replace(/\D/g, '');
                    if (digitsOnly.length <= 12) {
                      setMobile(value);
                    }
                  }
                  setError('');
                }}
                InputProps={{ disableUnderline: true }}
                className={classes.inputField}
                placeholder="Use country code along with number. (eg. +447875431081)"
              />
              {error && <p className={classes.errorMassage}>{error}</p>}
              <Button
                fullWidth
                className={classes.getCodeBtn}
                disabled={!mobile || loading}
                onClick={handleVerificationClick}
              >
                Get Verification Code via SMS
              </Button>
            </div>
          ))}

        {showVerification &&
          (loading ? (
            <div className="signingInWaitMain">
              <CircularProgress
                color="inherit"
                className="crcularprogressSignin"
              />
            </div>
          ) : (
            <>
              <p
                align="left"
                style={{ fontSize: 14, marginBottom: '10px', color: '#444444' }}
              >
                MFA Code
              </p>
              <Box className={classes.codeBox}>
                {Array.from({ length: slotsCount }).map((_, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <React.Fragment key={index}>
                    <input
                      type="text"
                      maxLength={1}
                      className={classes.codeInput}
                      value={code[index] || ''}
                      onChange={e => {
                        const newCode = [...code];
                        newCode[index] = e.target.value.replace(/[^0-9]/g, '');
                        setCode(newCode);

                        if (e.target.value && index < slotsCount - 1) {
                          const nextInput = document.getElementById(
                            `code-${index + 1}`,
                          );
                          if (nextInput) nextInput.focus();
                        }
                      }}
                      id={`code-${index}`}
                    />
                    {index < slotsCount - 1 && (
                      <span className={classes.dash}>-</span>
                    )}
                  </React.Fragment>
                ))}
              </Box>
              {error && <p className={classes.errorMassage}>{error}</p>}
              <Button
                fullWidth
                className={classes.confirmBtn}
                disabled={code.some(digit => !digit || digit.trim() === '')}
                onClick={handleConfirmCode}
              >
                Confirm
              </Button>
              <button
                type="button"
                className={classes.resend}
                onClick={resendVerification}
                disabled={disabled || loading}
              >
                {disabled ? `Resend Code (${timer}s)` : 'Resend Code'}
              </button>
              {resendError && (
                <p className={classes.errorMassage}>{resendError}</p>
              )}
            </>
          ))}
      </Card>
    </Box>
  );
}

export default MFASetup;
